






























import Component from 'vue-class-component';
import Vue from 'vue';
import TextInput from '@/general/component/form/input/TextInput.vue';
import { VModel } from 'vue-property-decorator';
import { required } from '@/common/validation/validation';
import ObisCodeAutocomplete from '@/common/component/ObisCodeAutocomplete.vue';
import { RegisterFormModel } from '@/context/model/model/RegisterFormModel';

@Component({
  components: {
    ObisCodeAutocomplete,
    TextInput
  }
})
export default class RegisterFormTemplate extends Vue {
  @VModel({ type: Object }) model!: RegisterFormModel;
  valid = true;

  get rules(): Record<string, unknown> {
    return {
      number: [required],
      unitSymbol: [required]
    };
  }
}
